export default function Card({ children, className = '', hover = false, glow = false, ...props }) {
  return (
    <div
      className={`bg-[#0f1623] border border-[rgba(148,163,184,0.06)] rounded-[10px] p-6 ${
        hover ? 'hover:border-[rgba(148,163,184,0.10)] transition-all cursor-pointer' : ''
      } ${glow ? 'card-glow' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '' }) {
  return <div className={`mb-4 ${className}`}>{children}</div>;
}

export function CardTitle({ children, className = '' }) {
  return <h3 className={`text-[14px] font-semibold text-[#e2e8f0] ${className}`}>{children}</h3>;
}
